import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithTeam } from '~/core/styleTypes';

import { centeredFlex } from '../../styles';

export const PeriodContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
`;

export const TimeContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}
    background: ${({ theme }) => theme.Table.zebraStripe};
    border: 1px solid ${({ theme }) => theme.Surface.border};
    border-radius: 8px;
    color: ${({ theme }) => theme.Text.primary};
    max-width: 56px;
    padding: 6px 8px;
    text-align: center;
    width: 100%;
`;

export const TimeColumn = styled.div<WithTeam & { $isGoalEvent: boolean }>`
    ${centeredFlex};
    flex: 1;
    flex-direction: column;
    gap: 6px;
    max-width: 72px;

    ${BaseStyle.Mixins.screenSizes.small} {
        max-width: 56px;
    }

    ${PeriodContainer} {
        color: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.textOnPrimary : theme.Text.secondary};
    }

    ${TimeContainer} {
        background-color: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.textOnPrimary : theme.Surface.primary};
        color: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.primary : theme.Text.primary};
        border-color: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.primary : theme.Surface.border};
    }
`;

export const LogoPlaceholder = styled.div<{ $isSmall?: boolean }>`
    flex: 1;
    max-width: ${({ $isSmall }) => ($isSmall ? '48px' : '72px')};
`;

export const PlayHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
`;

export const PlayDetails = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    flex-direction: column;
`;

export const PlayColumn = styled.div<WithTeam & { $isGoalEvent: boolean }>`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 6px;
    justify-content: center;
    padding: 0 16px;

    ${PlayHeader} {
        color: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.textOnPrimary : theme.Text.primary};
    }

    ${PlayDetails} {
        color: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.textOnPrimary : theme.Text.secondary};
    }

    span {
        color: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.textOnPrimary : theme.Text.secondary};
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        padding: 0 8px 0 0;
    }
`;

export const ExpandColumn = styled.div`
    ${centeredFlex};
    flex: 1;
    max-width: 48px;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['24m']}
        cursor: pointer;
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        max-width: 30px;
    }
`;

export const NestedPlayDetail = styled.span<{ $forceLowercase?: boolean }>`
    color: ${({ theme }) => theme.Text.secondary};
    ${({ $forceLowercase }) => ($forceLowercase ? 'text-transform: lowercase;' : '')}
`;

export const SecondaryAssist = styled.span<{ $showAssist: boolean }>`
    color: ${({ theme }) => theme.Text.secondary};
    display: ${({ $showAssist }) => ($showAssist ? 'initial' : 'none')};
`;
